/*
 * Title: Button/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Global Button use where we need & passing props for icons,text and action
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import twitter_new from "@assets/twitter_new.png";
import instagram_logo from "@assets/instagram.png";
import youtube_red_logo from "@assets/youtube_red.png";
import letter_logo from "@assets/logo_letter.png";
import tiktok_logo from "@assets/tiktok_logo.png";
import twitch_logo from "@assets/twitch_logo.png";
import shopify_logo from "@assets/shopify_logo.png";
import facebook from "@assets/facebook.png";
import discord_logo from "@assets/discord_logo.png";
import spotify_logo from "@assets/spotify_logo.png";
import typeform from "@assets/typeform.png";
import Logo from "@components/Logo";
import encoreActivateIcon from "@assets/encore_activate_icon.png";

const Icon: React.FC <any>= (props) => {
  const { icon, item,className } = props;

  return (
    <>
      {
        /* twitter icon */
        (icon === "Twitter" || icon === "twitter") && (
          <img src={twitter_new} alt="twitter" className={`${className ? className : 'w-10 h-10'} rounded-full`} />
        )
      }
      {
        /* facebook icon */
        (icon === "Facebook" || icon === "facebook") && (
          <img src={facebook} alt="facebook" className={`${className ? className : 'w-10 h-10'} rounded-full`} />
        )
      }
      {
        /* instagram icon */
        (icon === "Instagram" || icon === "instagram") && (
          <img src={instagram_logo} alt="Instagram" className={`${className ? className : 'w-10 h-10'} rounded-full`} />
        )
      }
      {
        /* Youtube icon */
        (icon === "Youtube" || icon === "youtube") && (
          <img src={youtube_red_logo} alt="Youtube" className={`${className ? className : 'h-10'}`} />
        )
      }
      {
        /* Youtube icon */
        ((icon === "Featured" || icon === "featured")) && (
          <Logo
            alt="Letter" className={`${className ? className : 'w-10 h-10'} rounded-full`} 
          />
        )
      }
      {
        /* Tiktok icon */
        (icon === "Tiktok" || icon === "tiktok") && (
          <img src={tiktok_logo} alt="Tiktok" className={`object-contain ${className ? className : 'h-10'}`} />
        )
      }
      {
        /* Twitch icon */
        (icon === "Twitch" || icon === "twitch") && (
          <img
            src={twitch_logo}
            alt="Twitch"
            className={`object-contain ${className ? className : 'w-10 h-10'}`}
          />
        )
      }
      {
        /* Twitch icon */
        (icon === "Partnerships" || icon === "partnerships") && (
          <img
            src={letter_logo}
            alt="Partnerships"
            className={`object-contain ${className ? className : 'w-10 h-10'}`}
          />
        )
      }
      {
        /* Shopify icon */
        (icon === "Shopify" || icon === "shopify") && (
          <img
            src={shopify_logo}
            alt="Shopify"
            className={`object-contain ${className ? className : 'w-10 h-10'}`}
          />
        )
      }
      {
        /* Discord icon */
        (icon === "Discord" || icon === "discord") && (
          <img
            src={discord_logo}
            alt="Discord"
            className={`object-contain ${className ? className : 'w-10 h-10'}`}
          />
        )
      }
      {
        /* Spotify icon */
        (icon === "Spotify" || icon === "spotify") && (
          <img
            src={spotify_logo}
            alt="Spotify"
            className={`object-contain ${className ? className : 'w-10 h-10'}`}
          />
        )
      }
      {
        /* encore */
        (icon === "Encore" || icon === "encore") && (
          <img
            src={encoreActivateIcon}
            alt="Encore logo is a E in a black circle"
            className={`object-contain ${className ? className : "w-10 h-10"}`}
          />
        )
      }
      {
        /* Typeform icon */
        (icon === "Typeform" || icon === "typeform") && (
          <img
            src={typeform}
            alt="Typeform"
            className={`object-contain ${className ? className : 'w-10 h-10'}`}
          />
        )
      }
       {
        /* Qrcode icon */
        // (icon === "QrCode" || icon === "qrCode") && (
        //   <img
        //     src={item?.url}
        //     alt="Spotify"
        //     className="object-contain w-10 h-10"
        //   />
        // )
      }
    </>
  );
};
export default Icon;
